import initialState from "./initialState";

// a reducer takes an action and the current state and returns a new state object, on the first time this is called,
// initial state will be our literal initialState variable defined in the initialState.js file.
const dataReducer = (state = initialState, action) => {
    let newState = null;
    // all actions are an object containing the keys type and payload, type is always a string
    switch (action.type) {
        case 'PAYLOAD_LOADED':
            // this is how we store the remote JSON into the state
            newState = Object.assign({}, state, {
                blob: action.payload
            });
            break;
        case 'APT_LEVEL_SELECTED':
            // this is some doodling, ignore for the time being
            newState = Object.assign({}, state, {
                selectedLevel: state.blob.levels[action.payload]
            });
            break;
        case 'HOVER_APT':
            // this is for when you mouse over an apartment plan to display the hover popup box
            newState = Object.assign({}, state, {
                hovered: action.payload
            });
            break;
        case 'HOVER_REMOVE_APT':
            // this clears the above, technically you could dispatch the above action with a null payload for the same result
            newState = Object.assign({}, state, {
                hovered: action.payload
            });
            break;
        case 'LEVEL_BUTTON_OVER':
            // handles hovering for the landing page (tower render the floor buttons, two-way interactivity)
            newState = Object.assign({}, state, {
                levelHover: action.payload
            });
            break;
        case 'LEVEL_BUTTON_OUT':
            // this clears the above, technically you could dispatch the above action with a null payload for the same result
            newState = Object.assign({}, state, {
                levelHover: null
            });
            break;
        default:
            // on default, we should not change state, i.e. return the current state
            newState = state;
            break;
    }

    // always prefer one exit point over multiple return statements which are hard to follow and reason about
    return newState;
};

export default dataReducer;


// WEBPACK FOOTER //
// ./src/reducers/dataReducer.js